import React, { useState, useMemo, useEffect } from "react";
import dynamic from "next/dynamic";
import {
  _formatArray,
  generateAmazonBookPreviewLink,
  shorten,
  amazonAsinParser,
  formatBookDetailUrl,
  BuildServerlessBookCoverImageUrl,
  isFutureDate,
  formatPrice,
} from "../../helpers/Helper";
// import NextImage from "@components/Image/NextImage";
import DealsPageAffiliateButton from "./DealsPageAffiliateButton";
import { useAppContext } from "@components/Provider";
import slugify from "slugify";
import Link from "next/link";
import SITES from "../../constants/Sites";
import IMAGESIZES from "../../constants/IMAGESIZES";

import styles from "./DealsPageBooks.module.css";
import "./DealsPageBooks.css";

const NextImage = dynamic(() => import("@components/Image/NextImage"));

const DealsPageBooks = (props) => {
  const { dealsPageBookProps, preferredRetailer, retailerFromURL, pageUrl } = props;
  let { data, isMobile, isTablet, siteId } = useAppContext(),
    { SiteSettings } = data || {},
    previewLinkAffiliateCode = SiteSettings?.preview_link_affiliate_code;
  const [showDescription, setShowDescription] = useState(false);
  const { image, title, authors, urlType, dlp, price, amazonLink, primary_isbn } =
    dealsPageBookProps.affiliate.props;
  const {
    salePrice,
    description,
    renderDescription,
    renderPreview,
    renderOnSale,
    renderPrimaryAuthors,
    titleText = "ON SALE NOW",
    interestPage,
  } = dealsPageBookProps;

  const bookRef = React.createRef();

  const findPosition = (obj) => {
    let currentTop = -80;
    if (obj.offsetParent) {
      do {
        currentTop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
      return [currentTop];
    }
  };

  useEffect(() => {
    if (pageUrl) {
      const url = new URL(pageUrl);
      const isbn = url.searchParams.get("isbn");
      if (bookRef.current.id === isbn) {
        window.scrollTo(0, findPosition(bookRef.current));
      }
    }
  }, []);

  const renderBookImage = () => {
    let bookCoverUrl = BuildServerlessBookCoverImageUrl(
      IMAGESIZES.BC_DEALSPAGE,
      image?.props?.image?.Name || image || null
    );

    const previewLinkInner = (
      <span className="dealspage__read_preview">
        <NextImage
          ImageUrl={`${process.env.S3_IMAGE_URL}/eye.svg`}
          Title="Read Preview"
          Alt_Text="Read Preview"
          className=""
          width={16}
          height={16}
          style={{
            verticalAlign: "middle",
          }}
          isLazyload={true}
        />
        <span style={{ marginLeft: "5px" }}>READ PREVIEW</span>
      </span>
    );
    return (
      <div className={"dealspage__bookimage"}>
        {renderAmazonPreviewLink(bookCoverUrl, previewLinkInner, "afb__preview-link")}
      </div>
    );
  };

  const getSalePriceValue = () => {
    if (salePrice != null && typeof salePrice == "object" && salePrice.hasOwnProperty("props")) {
      return salePrice.props.value;
    }
    return salePrice;
  };

  const renderSalePrice = () => {
    const salePrice = getSalePriceValue();
    const { country } = dealsPageBookProps && dealsPageBookProps;
    const renderComingSoonBanner = isFutureDate(dealsPageBookProps?.affiliate?.props?.pub_date);
    let countryCurrencySymbol = (country && country.symbol) || "$";
    const origPrice =
      urlType == "External Link" && dlp != "" ? dlp : urlType == "Internal Link" ? price : "";
    const normalizedSalePrice =
      typeof salePrice === "string" ? salePrice.replace(/<\/?[^>]+(>|$)/g, "").trim() : salePrice;
    const numericSalePrice =
      typeof normalizedSalePrice === "string"
        ? normalizedSalePrice.replace(/[^0-9.-]/g, "")
        : normalizedSalePrice;
    const salePriceFloat =
      numericSalePrice !== "" && numericSalePrice != null ? parseFloat(numericSalePrice) : null;
    // 0 is a valid sale price. It is falsy, so it cannot be used as a "has price" check.
    const hasSalePrice = salePriceFloat != null && !Number.isNaN(salePriceFloat);
    if (hasSalePrice || origPrice) {
      // formatPrice prefixes "$" for numbers. This row already prints countryCurrencySymbol, so keep the amount only.
      const amountOnly = (value) => String(formatPrice(value) ?? "").replace(/^\$/, "");
      const formattedSalePrice = hasSalePrice ? salePriceFloat.toFixed(2) : amountOnly(salePrice);
      let displayFreeVoiceBanner = dealsPageBookProps.freevoice;
      return (
        <div className={[styles["sale_price"], "sale_price"].join(" ")}>
          {
            renderComingSoonBanner ? (
              <div>
                <span>
                  <NextImage
                    name={"c44ec8d3e03a-coming_soon_tag-green.png"}
                    width={140}
                    height={32}
                    isLazyload={true}
                  />
                </span>
              </div>
            ) : displayFreeVoiceBanner ? (
              <div>
                <a
                  href="https://earlybirdbooks.com/free-voices"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <NextImage
                    name={"e6662ba6c372-freevoice.jpg"}
                    width={140}
                    height={32}
                    isLazyload={true}
                  />
                </a>
              </div>
            ) : (
              <></>
            )
            // (
            //   getOperator(operator, salePriceFloat, price) && (
            //     <div>
            //       <NextImage
            //         name={bannerInfo && bannerInfo?.name}
            //         Title={title}
            //         Alt_Text={title}
            //         width={bannerInfo && bannerInfo?.width}
            //         height={bannerInfo && bannerInfo?.height}
            //         isLazyload={true}
            //       />
            //     </div>
            //   )
            //)
          }
          <div className={[styles["deals-sale"], "deals-sale"].join(" ")}>
            <span className={[styles["sale_price"], "sale_price"].join(" ")}>
              {hasSalePrice ? (
                <span
                  className={[styles["deals_page__dollar_sign"], "deals_page__dollar_sign"].join(
                    " "
                  )}
                >
                  {countryCurrencySymbol}
                </span>
              ) : null}
              <span
                className={[styles["dealspage__saleprice_text"], "dealspage__saleprice_text"].join(
                  " "
                )}
              >
                {hasSalePrice ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `<p>${formattedSalePrice}</p>`,
                    }}
                  />
                ) : null}
              </span>
            </span>
            {origPrice !== "" && origPrice != null ? (
              <p
                className={[
                  styles["deals-dlp"],
                  "deals-dlp",
                  hasSalePrice ? styles["deals-dlp-salePrice"] : "",
                ].join(" ")}
              >{`${countryCurrencySymbol} ${amountOnly(origPrice)}`}</p>
            ) : null}
          </div>
        </div>
      );
    }
  };

  const renderAuthor = () => {
    let _author;
    const authorNames = (names) => {
      return <div className={[styles["afb__author"], "afb__author"].join(" ")}>by {names}</div>;
    };
    const authorNamesArray = (names) => {
      let authorsHTML = names.map(({ displayName, slug }, i) => {
        const hasValidSlug = slug && slug !== "null" && slug !== "undefined";

        return (
          <React.Fragment key={`author-${i}`}>
            {i > 0 && i === names.length - 1 ? " and " : i !== 0 && ", "}
            {hasValidSlug ? (
              <Link href={`/contributor/${slug}`} target="_blank" rel="noopener">
                {displayName}
              </Link>
            ) : (
              <span>{displayName}</span>
            )}
          </React.Fragment>
        );
      });

      return (
        <div className={[styles["afb__author"], "afb__author"].join(" ")}>by {authorsHTML}</div>
      );
    };
    if (authors) {
      let _authorNames;
      if (renderPrimaryAuthors) {
        _authorNames = authors.map((author) => {
          if (author.role === 1 || author.Role === 1) {
            if (siteId === SITES.OPENROADMEDIA) {
              return typeof author === "object"
                ? {
                    displayName: author.Display_Name || author.display_name,
                    slug: author.slug || author.Slug,
                  }
                : author;
            } else {
              return typeof author === "object"
                ? author.Display_Name || author.display_name
                : author;
            }
          }
        });
      } else {
        _authorNames = authors.map((author) => {
          return typeof author === "object" ? author.Display_Name || author.display_name : author;
        });
      }
      _authorNames = _authorNames.filter((notUndefined) => notUndefined !== undefined);

      if (siteId !== SITES.OPENROADMEDIA) {
        _author = authorNames(_formatArray(_authorNames, ", ", " and "));
      } else {
        _author = authorNamesArray(_authorNames);
      }
    }
    return _author;
  };

  const renderTitle = () => {
    let bookTitleHTML;

    if (siteId === SITES.OPENROADMEDIA) {
      bookTitleHTML = (
        <Link
          href={formatBookDetailUrl(primary_isbn, slugify(title))}
          target="_blank"
          rel="noopener"
        >
          <div
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </Link>
      );
    } else {
      bookTitleHTML = (
        <div
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      );
    }
    return (
      <h3 className={[styles.afb__title, "afb__title"].join(" ")}>
        {bookTitleHTML}
        {renderAuthor()}
      </h3>
    );
  };

  const renderAmazonPreviewLink = (bookCoverUrl, innerContent, className) => {
    let previewLink = "",
      asin = "";
    if (amazonLink) {
      previewLink = generateAmazonBookPreviewLink(amazonLink, previewLinkAffiliateCode);
      asin = amazonAsinParser(amazonLink);
    }
    const bookImageHTML = (
      <NextImage
        ImageUrl={bookCoverUrl}
        Title={title}
        Alt_Text={"Buy " + title + " at Amazon"}
        width={179}
        height={254}
        isLazyload={true}
      />
    );
    const previewLinkHTML = (
      <a
        href={`${previewLink}`}
        target="_blank"
        rel="noopener noreferrer"
        data-vars-book-preview-event-label={asin}
      >
        {innerContent}
      </a>
    );
    if (previewLink && asin && siteId !== SITES.OPENROADMEDIA) {
      return (
        <>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${previewLink}`}
            data-vars-book-preview-event-label={asin}
          >
            {bookImageHTML}
          </a>
          {renderPreview !== false && asin ? (
            <div className={className}>{previewLinkHTML}</div>
          ) : (
            ""
          )}
        </>
      );
    } else if (siteId === SITES.OPENROADMEDIA && previewLink && asin) {
      return (
        <>
          <Link
            href={formatBookDetailUrl(primary_isbn, slugify(title))}
            target="_blank"
            rel="noopener noreferrer"
          >
            {bookImageHTML}
          </Link>
          <div className={className}>{previewLinkHTML}</div>
        </>
      );
    } else {
      return (
        <>
          {bookImageHTML}
          <div className={className}>No Preview</div>
        </>
      );
    }
  };

  const handleDescription = () => {
    setShowDescription(!showDescription);
  };

  const renderAffiliateButton = (isbn) => (
    <DealsPageAffiliateButton
      {...dealsPageBookProps.affiliate.props}
      preferredRetailer={preferredRetailer}
      bookId={isbn}
      retailerFromURL={retailerFromURL}
      buttonText={"Buy"}
    />
  );

  const renderBooks = () => {
    let bookDescription = description?.props?.value || "";
    const plainBookDescription = bookDescription.replace(/<[^>]*>/g, "");
    const shortDescription = shorten(plainBookDescription, isMobile || isTablet ? 75 : 320);

    return (
      <>
        <div
          className={[styles["dealspage__book"], "dealspage__book"].join(" ")}
          id={primary_isbn}
          ref={bookRef}
          style={{ "--interestPage": interestPage ? 1 : 0 }}
        >
          <div className={[styles["dealspage__bookcontent"], "dealspage__bookcontent"].join(" ")}>
            {useMemo(() => renderBookImage(), [primary_isbn])}
            <div className={[styles["dealspage__book_detail"], "dealspage__book_detail"].join(" ")}>
              {renderOnSale ? (
                <h3
                  className={[
                    styles["dealspage__book__on-sale-now"],
                    "dealspage__book__on-sale-now",
                  ].join(" ")}
                >
                  {titleText}
                </h3>
              ) : null}
              {useMemo(() => renderTitle(), [primary_isbn])}
              <React.Fragment>
                {renderDescription !== false &&
                  (showDescription ? (
                    <div
                      className="afb__description"
                      dangerouslySetInnerHTML={{ __html: bookDescription }}
                    ></div>
                  ) : (
                    <p className="afb__description">{shortDescription}</p>
                  ))}
                <span
                  className={[
                    styles["dealspage_book_read_more_link"],
                    "dealspage_book_read_more_link",
                  ].join(" ")}
                  onClick={handleDescription}
                >
                  {renderDescription !== false &&
                  bookDescription &&
                  bookDescription.length >= (isMobile || isTablet ? 75 : 320)
                    ? showDescription
                      ? "Read Less..."
                      : "Read More..."
                    : null}
                </span>
              </React.Fragment>

              {renderSalePrice()}
              {interestPage
                ? useMemo(
                    () => renderAffiliateButton(primary_isbn),
                    [preferredRetailer, primary_isbn]
                  )
                : null}
            </div>
          </div>
          {!interestPage &&
            useMemo(() => renderAffiliateButton(primary_isbn), [preferredRetailer, primary_isbn])}
        </div>
      </>
    );
  };
  return <React.Fragment>{renderBooks()}</React.Fragment>;
};

export default DealsPageBooks;
